import af from 'date-fns/locale/af';
import enUS from 'date-fns/locale/en-US';
import az from 'date-fns/locale/az';
import be from 'date-fns/locale/be';
import bg from 'date-fns/locale/bg';
import bn from 'date-fns/locale/bn';
import ca from 'date-fns/locale/ca';
import cs from 'date-fns/locale/cs';
import cy from 'date-fns/locale/cy';
import da from 'date-fns/locale/da';
import de from 'date-fns/locale/de';
import el from 'date-fns/locale/el';
import eo from 'date-fns/locale/eo';
import es from 'date-fns/locale/es';
import et from 'date-fns/locale/et';
import eu from 'date-fns/locale/eu';
import fi from 'date-fns/locale/fi';
import fr from 'date-fns/locale/fr';
import gd from 'date-fns/locale/gd';
import gl from 'date-fns/locale/gl';
import gu from 'date-fns/locale/gu';
import he from 'date-fns/locale/he';
import hi from 'date-fns/locale/hi';
import hr from 'date-fns/locale/hr';
import hu from 'date-fns/locale/hu';
import hy from 'date-fns/locale/hy';
import id from 'date-fns/locale/id';
import is from 'date-fns/locale/is';
import it from 'date-fns/locale/it';
import ja from 'date-fns/locale/ja';
import ka from 'date-fns/locale/ka';
import kk from 'date-fns/locale/kk';
import kn from 'date-fns/locale/kn';
import ko from 'date-fns/locale/ko';
import lb from 'date-fns/locale/lb';
import lt from 'date-fns/locale/lt';
import lv from 'date-fns/locale/lv';
import mk from 'date-fns/locale/mk';
import ms from 'date-fns/locale/ms';
import mt from 'date-fns/locale/mt';
import nb from 'date-fns/locale/nb';
import nl from 'date-fns/locale/nl';
import nn from 'date-fns/locale/nn';
import pl from 'date-fns/locale/pl';
import pt from 'date-fns/locale/pt';
import ro from 'date-fns/locale/ro';
import ru from 'date-fns/locale/ru';
import sk from 'date-fns/locale/sk';
import sl from 'date-fns/locale/sl';
import sr from 'date-fns/locale/sr';
import sv from 'date-fns/locale/sv';
import ta from 'date-fns/locale/ta';
import te from 'date-fns/locale/te';
import th from 'date-fns/locale/th';
import tr from 'date-fns/locale/tr';
import ug from 'date-fns/locale/ug';
import uk from 'date-fns/locale/uk';
import uz from 'date-fns/locale/uz';
import vi from 'date-fns/locale/vi';

export const existLocales = {
    af: af,
    az: az,
    be: be,
    bg: bg,
    bn: bn,
    ca: ca,
    cs: cs,
    cy: cy,
    da: da,
    de: de,
    el: el,
    eo: eo,
    es: es,
    et: et,
    eu: eu,
    en: enUS,
    fi: fi,
    fr: fr,
    gd: gd,
    gl: gl,
    gu: gu,
    he: he,
    hi: hi,
    hr: hr,
    hu: hu,
    hy: hy,
    id: id,
    is: is,
    it: it,
    ja: ja,
    ka: ka,
    kk: kk,
    kn: kn,
    ko: ko,
    lb: lb,
    lt: lt,
    lv: lv,
    mk: mk,
    ms: ms,
    mt: mt,
    nb: nb,
    nl: nl,
    nn: nn,
    pl: pl,
    pt: pt,
    ro: ro,
    ru: ru,
    sk: sk,
    sl: sl,
    sr: sr,
    sv: sv,
    ta: ta,
    te: te,
    th: th,
    tr: tr,
    ug: ug,
    uk: uk,
    uz: uz,
    vi: vi
};

export const existMoment = {
    af: 'af',
    ar: 'ar',
    az: 'az',
    be: 'be',
    bg: 'bg',
    bm: 'bm',
    bn: 'bn',
    bo: 'bo',
    br: 'br',
    bs: 'bs',
    ca: 'ca',
    cs: 'cs',
    cv: 'cv',
    cy: 'cy',
    da: 'da',
    de: 'de',
    dv: 'dv',
    el: 'el',
    en: 'en-gb',
    eo: 'eo',
    es: 'es',
    et: 'et',
    eu: 'eu',
    fa: 'fa',
    fi: 'fi',
    fil: 'fil',
    fo: 'fo',
    fr: 'fr',
    fy: 'fy',
    ga: 'ga',
    gd: 'gd',
    gl: 'gl',
    gu: 'gu',
    he: 'he',
    hi: 'hi',
    hr: 'hr',
    hu: 'hu',
    hy: 'hy-am',
    id: 'id',
    is: 'is',
    it: 'it',
    ja: 'ja',
    jv: 'jv',
    ka: 'ka',
    kk: 'kk',
    km: 'km',
    kn: 'kn',
    ko: 'ko',
    ku: 'ku',
    ky: 'ky',
    lb: 'lb',
    lo: 'lo',
    lt: 'lt',
    lv: 'lv',
    me: 'me',
    mi: 'mi',
    mk: 'mk',
    ml: 'ml',
    mn: 'mn',
    mr: 'mr',
    ms: 'ms',
    mt: 'mt',
    my: 'my',
    nb: 'nb',
    ne: 'ne',
    nl: 'nl',
    nn: 'nn',
    oc: 'oc-lnc',
    pa: 'pa-in',
    pl: 'pl',
    pt: 'pt',
    ro: 'ro',
    ru: 'ru',
    sd: 'sd',
    se: 'se',
    si: 'si',
    sk: 'sk',
    sl: 'sl',
    sq: 'sq',
    sr: 'sr',
    ss: 'ss',
    sv: 'sv',
    sw: 'sw',
    ta: 'ta',
    te: 'te',
    tet: 'tet',
    tg: 'tg',
    th: 'th',
    tk: 'tk',
    tl: 'tl-ph',
    tlh: 'tlh',
    tr: 'tr',
    tzl: 'tzl',
    tzm: 'tzm',
    ug: 'ug-cn',
    uk: 'uk',
    ur: 'ur',
    uz: 'uz',
    vi: 'vi',
    x: 'x-pseudo',
    yo: 'yo',
    zh: 'zh-cn'
};
